export default __webpack_public_path__ + "static/media/Project-4-PortfolioPage-MainImg.e439e054.png";